import React from "react";
import Translation from "utils/Translation";

const SimulatorBilan = ({ onEdit }) => {
  return (
    <>
      <div className="simulator_P2_header" />
      <div className="simulator_P3_bilan">
        <h2 className="simulator_P3_title">
          <Translation tag="Simulator_Results_ConfirmationTitle" />
        </h2>
        <span className="simulator_P3_text">
          <Translation tag="Simulator_Results_ConfirmationText" />
        </span>
        <button className="simulate-button simulator_P3_button" onClick={onEdit}>
          <Translation tag="Simulator_Results_NewSimulation" />
        </button>
      </div>
    </>
  );
};

export default SimulatorBilan;
